import { lensApi } from "@/services/lensApi";

export interface MonitorableParameterDto {
	id: number;
	name: string;
	description: string;
	defaultMin: number | null;
	defaultMax: number | null;
	decimals: number;
	unitId: number;
	unitName: string;
	unitSymbol: string;
}

export type MonitorableParameterType = "Device" | "Hydraulic";

export const parameters = {
	getParameters: async (): Promise<Dryp.Parameter[]> => {
		return lensApi.get<Dryp.Parameter[]>(`/parameters`);
	},

	getMonitorableParameters: async (parameterType: MonitorableParameterType): Promise<MonitorableParameterDto[]> => {
		return lensApi.get<MonitorableParameterDto[]>(`/parameters/monitorable/${parameterType}`);
	},
};
